<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <!-- <fg-input label="Bestellungen Absender E-Mail Adresse" type="email" v-model="orderEmail" /> -->
          <fg-input label="Bestell E-Mail Betreff" type="textarea" v-model="emailSubject" />
          <div class="form-group has-label">
            <label>E-Mail Standardtext | Kopfzeile allgemein</label>
            <textarea class="form-control" v-model="orderEmailDefaultText" rows="3"></textarea>
          </div>

          <div class="form-group has-label">
            <label>Bestell E-Mail Standardzusatztext für neue Lieferanten</label>
            <textarea class="form-control" v-model="orderEmailSupplierText" rows="3"></textarea>
          </div>

          <div class="form-group has-label">
            <label>Bestell E-Mail Standardzusatztext für neue Läger</label>
            <textarea class="form-control" v-model="orderEmailWarehouseText" rows="3"></textarea>
          </div>
          <div class="form-group has-label">
            <label>Bestell E-Mail Produkttext</label>
            <textarea class="form-control" v-model="orderEmailProductText" rows="3"></textarea>
          </div>
          <div class="form-group has-label">
            <label>Bestell E-Mail Signatur</label>
            <textarea class="form-control" v-model="orderEmailEndText" rows="3"></textarea>
          </div>
          <div  class="form-group has-label">
            <label>Mehrwertsteuersätze</label>
            <br>

            <div style="display: grid; grid-template-columns: 1fr 1fr;">
              <label>Label</label>
              <label>Wert</label>

            </div>
            <div v-for="(tax, index) in taxes" :key="index" style="display: flex; align-items: center;">
              <input class="form-control" style="border: 1px solid grey;" v-model="tax.label">
              <input class="form-control" style="border: 1px solid grey;" v-model="tax.value">
              <div style="cursor: pointer; padding: 5px;" @click="removeTax(index)"> <i class="fa fa-minus"></i></div>
            </div>
            <div style="cursor: pointer;  padding: 5px;" @click="addTax"> <i class="fa fa-plus"></i></div>
          </div>

          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderEmail: '',
      emailSubject: '',
      orderEmailDefaultText: '',
      orderEmailSupplierText: '',
      orderEmailWarehouseText: '',
      orderEmailProductText: '',
      orderEmailEndText: '',
      taxes: []
    }
  },
  methods: {
    async submit() {
      await this.initCsrf()

      this.$http.put('/settings', {
        order_email: this.orderEmail,
        email_subject: this.emailSubject,
        order_email_default_text: this.orderEmailDefaultText,
        order_email_supplier_text: this.orderEmailSupplierText,
        order_email_warehouse_text: this.orderEmailWarehouseText,
        order_email_product_text: this.orderEmailProductText,
        order_email_end_text: this.orderEmailEndText,
        taxes: this.taxes,
      }).then(() => {
        this.$notify({
          message: 'Allgemeine Einstellungen erfolgreich gespeichert.',
          type: 'success'
        })
      })
    },
    addTax() {
      this.taxes.push({ label: "", value: "" });
    },
    removeTax(index) {
      this.taxes.splice(index, 1);
    }
  },
  created() {
    this.$http.get('/settings').then(({ data }) => {
      this.orderEmail = data.order_email
      this.emailSubject = data.email_subject
      this.orderEmailDefaultText = data.order_email_default_text
      this.orderEmailSupplierText = data.order_email_supplier_text
      this.orderEmailWarehouseText = data.order_email_warehouse_text
      this.orderEmailProductText = data.order_email_product_text
      this.orderEmailEndText = data.order_email_end_text
      this.taxes = JSON.parse(data.taxes)
      this.signature = data.signature
    })
    this.$http.get('/auth/user').then(({ data }) => {
      this.signature = data.signature
      this.use_sig_to_all = data.use_sig_to_all === 1 ? true : false
      this.user = data;
    })
  }
}
</script>

<style></style>
